// [BD feat] Image Gallery — bd-image-gallery.js
// Drag to scroll (QA 2026-10-08, Figma comment #360): the dev note asks for a horizontal, swipeable row.
// Touch and trackpads already scroll the track natively; a mouse had no way to move it. A mouse drag now
// scrolls the row, snap is held off while dragging (the row settles on a tile on release), and a drag never
// counts as a click on a tile. Keyboard: the track is focusable, arrow keys scroll it natively.
(function () {
  'use strict';

  var SELECTOR = '.bd-image-gallery__track--desktop-horizontal, .bd-image-gallery__track--mobile-horizontal';

  function bind(track) {
    if (track.dataset.bdDragBound) return;
    track.dataset.bdDragBound = '1';

    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) {
        moved = true;
        track.setPointerCapture(e.pointerId);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      if (track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
      // Snap back on with the row where the drag left it: the browser settles it on the nearest tile
      var left = track.scrollLeft;
      track.classList.remove('is-dragging');
      track.scrollLeft = left;
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // A drag is not a click
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    // No ghost-image drag of the photos
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function scan(root) { (root || document).querySelectorAll(SELECTOR).forEach(bind); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
// [BD feat] Image Gallery
